import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import useProgressiveImg from "../../hooks/useProgressiveImg";
import "./home.css";

const enterFromBelow = { y: 20, opacity: 1 };
const entranceTransition = { ease: "easeOut", duration: 1.5 };
const copyTransition = { ...entranceTransition, delay: 0.25 };
const actionsTransition = { ...entranceTransition, delay: 0.5 };
const footerTransition = { ...entranceTransition, delay: 0.75 };
const hiddenStyle = { opacity: 0 };

const Home = () => {
  const [src, { blur }] = useProgressiveImg(
    "./background-tiny.jpg",
    "./background.jpg"
  );

  return (
    <main>
      <motion.div
        animate={{ opacity: 1 }}
        transition={entranceTransition}
        className="background"
        style={{
          backgroundImage: `url(${src})`,
          filter: blur ? "blur(20px)" : "none",
          transition: blur ? "none" : "filter 0.3s ease-out",
          opacity: 0,
        }}
      />
      <div className="container">
        <motion.div
          animate={enterFromBelow}
          transition={entranceTransition}
          style={hiddenStyle}
        >
          <h1>From complex ideas to clear digital products.</h1>
        </motion.div>
        <div className="spacer-large" />
        <motion.div
          animate={enterFromBelow}
          transition={copyTransition}
          style={hiddenStyle}
        >
          <p className="body">
            I’m Oleksii, a digital product designer with 10+ years of experience
            working with startups, product companies, and global organizations.
          </p>

          <div className="spacer-small" />

          <p className="body">
            I help teams understand difficult product problems, turn them into
            coherent systems, and design experiences that are useful, scalable,
            and visually strong.
          </p>
        </motion.div>
        <div className="spacer-large" />
        <motion.div
          className="buttons"
          animate={enterFromBelow}
          transition={actionsTransition}
          style={hiddenStyle}
        >
          <Link
            className="primary"
            to="/capabilities"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Capabilities
          </Link>
          <Link
            className="secondary"
            to="/walkthrough"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Selected Work
          </Link>
          <a className="secondary" href="mailto:hey@ttrnk.com">
            Email Me
          </a>
        </motion.div>
        <motion.div
          className="ukraine"
          layout
          animate={{ y: [-20, 0], opacity: 1 }}
          transition={footerTransition}
          style={hiddenStyle}
        >
          <p className="caption">
            🇺🇦 Support Ukraine. Visit{" "}
            <a
              href="https://war.ukraine.ua"
              target="_blank"
              rel="noopener noreferrer"
            >
              war.ukraine.ua
            </a>{" "}
            to learn more.
          </p>
        </motion.div>
      </div>
    </main>
  );
};

export default Home;
